import "./chatBubble.scss";

interface ChatBubbleProps {
    text: string;
    type?: "send" | "receive";
    maxWidth?: boolean;
}

const urlRegex = /(\bhttps?:\/\/[^\s]+)/g;
const isUrl = (str: string) => urlRegex.test(str);

export const ChatBubble = ({ text, type = "receive", maxWidth = false }: ChatBubbleProps) => {
    const parsedText = text.split(urlRegex);

    return (
        <p className={`chat-bubble chat-bubble-${type} ${maxWidth ? "chat-bubble-max-width" : ""}`}>
            {parsedText.map((text, index) =>
                isUrl(text) ? (
                    <span key={`url-${index / 2}`} style={{ textDecoration: "underline" }}>
                        {text}
                    </span>
                ) : (
                    text
                ),
            )}
        </p>
    );
};

export default ChatBubble;
